import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { CommonModule } from '@angular/common'

export const BOOKING_COLOUR_SWATCHES = [
    '#3D4BBE',
    '#ED3C3F',
    '#EF9C43',
    '#D58DC3',
    '#4CAF50',
] as const

@Component({
    selector: 'app-colour-swatch-selector',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './colour-swatch-selector.component.html',
    styleUrl: './colour-swatch-selector.component.sass',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ColourSwatchSelectorComponent {

    @Input({ required: true }) colours: readonly string[] = []
    @Input({ required: true }) inputId!: string
    @Input() label: string | null = null
    @Input() helpText?: string
    @Input() selectedColour: string | null = null
    @Input() allowDefault = false

    @Output() selectedColourChange = new EventEmitter<string | null>()

    selectColour(colour: string | null) {
        this.selectedColourChange.emit(colour)
    }

    optionId(index: number): string {
        return `${this.inputId}-${index + 1}`
    }
}
